import { useQuery } from "@tanstack/react-query";
import { AppConfig } from "../interfaces/appIntegration.interfaces";
import { AppState } from "../types/appIntegration.types";
import { getAppIntegrationStatus } from "../actions/getAppIntegrationStatus";

export const useGetAppIntegrationStatus = (app: AppConfig) => {
  return useQuery<AppState>({
    queryKey: ["appStatus", app.id],
    queryFn: () => getAppIntegrationStatus(app.id),
  });
};  